/**
 * Filtre les visiteurs
 */
import _watcheebox from '../components/watcheebox/watcheebox.js'
import { mapGetters, mapState } from 'vuex'
import _ from 'lodash'
export default {
  data () {
    return {
      idInterval: null,
      monitorRequest: false,
      visiteurData: {},
      // tableau des visiteurs de monitor
      datasMonitorVisiteurs: [],
      filterFront: Number(this.$store.state._User.filterFront)
    }
  },

  mounted () {
    // effectuer une requette dans la mixin 'monitor' vers "monitor.php" pour le classement des visiteurs
    // si le filtrage ne ce fait pas en front
    // lance le monitor
    if (!this.filterFront) {
      if (this.level.monitor) {
        this.initMonitor()
      }
    }
  },

  watch: {
    '$store.state._StoreWatcheeBox.status': function (v) {
      if (v === 'online' && this.level.monitor && !this.monitorRequest) {
        // si le filtrage ne ce fait pas en front
        // lance le monitor
        if (!this.filterFront) {
          this.checkInfosVisiteurs()
        }
      }
    }
  },

  methods: {
    // ----------------------------------------------------------------------------
    // Init monitor
    // ----------------------------------------------------------------------------
    initMonitor () {
      // console.log('initMonitor')
      // lancement initial du monitor si pas déjà lancé
      if (!this.monitorRequest) {
        this.checkInfosVisiteurs()
      }
      // toutes les x millisecondes en fonction du niveau de la licence
      this.idInterval = setInterval(() => {
        // si c'est libre pour lancer une requette monitor
        if (!this.monitorRequest) {
          this.checkInfosVisiteurs()
        }
      }, this.level.monitor)
    },

    // ----------------------------------------------------------------------------
    // Stop le monitor
    // ----------------------------------------------------------------------------
    stopMonitor () {
      clearInterval(this.idInterval)
    },

    // ----------------------------------------------------------------------
    // enregistre dans le store le focus de l'agent
    // ----------------------------------------------------------------------
    focusView (data) {
      // supprime la/les notification(s), associée(s) au visiteur focused
      let indexNotif = -1
      _.each(this.$store.state._Notifier.notifications, (notif, idx) => {
        if (notif.data && notif.data.visiteurID === data.visiteurID) {
          indexNotif = idx
        }
      })
      // console.log('focusView', this.$store.state._Notifier.notifications)
      // console.log('indexNotif', indexNotif)
      if (indexNotif !== -1) {
        this.$store.commit('_Notifier/REMOVE_NOTIF', indexNotif)
      }
      this.$store.commit('_StoreWatcheeBox/AGENT_FOCUS', data)
      if (data.view !== this.focusPupitre.view) {
        // envois au serveur le nouveau focus visiteur
        _watcheebox.changeFocusAgent({
          socket: this.$socket,
          datasAgent: this.user,
          focusSessionID: data.visiteurID,
          focusAgent: true
        })
      }
    },

    // ----------------------------------------------------------------------------
    // Mise à jour de l'hitorique de chat
    // ----------------------------------------------------------------------------
    MonitorMajHistoChat (data) {
      this.datasMonitorVisiteurs = data
      console.log('maj histoChat dans monitor', this.datasMonitorVisiteurs)
    },

    // ----------------------------------------------------------------------------
    // Check les infos visiteurs connectés
    // ----------------------------------------------------------------------------
    checkInfosVisiteurs () {
      console.log('checkInfosVisiteurs')
      // Vérifie que l'agent est bien 'online'
      // si ce n'est pas le cas, filtrage 'light'
      // qui supprime les visiteurs non connectés
      if (this.$store.state._StoreWatcheeBox.status !== 'online') {
        this.datasMonitorVisiteurs = _.cloneDeep(this.listeAllVisiteurs)
        this.modifVisiteursMonitor()
        return
      }
      this.monitorRequest = true // lance une requette

      // nouveau tableau avec les id des visiteurs
      var newArray = []
      _.forEach(this.listeAllVisiteurs, function (visiteur, key) {
        var newTab = [
          visiteur.status,
          visiteur.lang,
          visiteur.visiteurID,
          visiteur.roomName
        ]
        newArray.push(newTab)
      })

      var config = {
        responseType: 'json',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }

      // ##############################
      // Evois en POST
      // ##############################
      let dataToPost = new window.FormData()
      dataToPost.append('key', this.user.key)
      dataToPost.append('listVis', JSON.stringify(newArray))
      dataToPost.append('nbChatMax', this.user.chatsMax)
      dataToPost.append('keyEnt', this.user.entKey)
      // dataToPost.append('specialtable', this.user.licSpecialtable)
      dataToPost.append('allLic', this.user.licAllKeys.join('|'))
      // dataToPost.append('ulu', 'a:3:{s:6:"azerty";s:33:"http://reservation.visiofair.info";s:32:"948580a42a7ace75df2befcdf0ec8a81";s:31:"http://prestashop.watcheezy.com";s:32:"bd5400e792965ecf0a6dbb099d66397b";s:30:"http://prestashop.watcheezy.es";}')
      // dataToPost.append('reduced', '')
      // dataToPost.append('focusId', '')
      // dataToPost.append('listIncoming', [])
      dataToPost.append('listOpened', this.allChatsOpened)
      // dataToPost.append('listWaiting', [])
      // dataToPost.append('listIsChatting', [])
      dataToPost.append('lang', this.user.licLang)
      // dataToPost.append('ll', '7')
      // dataToPost.append('desk_refresh', '20000')
      dataToPost.append('agentAvailability', this.user.dispo)
      // dataToPost.append('lastAutoMsg', '')
      dataToPost.append('mUrl', this.user.multiSite)
      dataToPost.append('exclusion', this.user.user_sites)
      // dataToPost.append('nbOpenedTabs', '0')

      this.axios
        .post('post/monitor.php', dataToPost, config)
        .then(response => {
          // console.log('response.data', response.data)
          if (!_.isNil(response.data)) {
            // on recupere les anciennes dates de 'firstchat' pour les effacer si il y a des '|' dedans
            _.forEach(response.data, (dataChatVisiteur, key) => {
              if (
                dataChatVisiteur.dateLastChat &&
                dataChatVisiteur.dateLastChat.indexOf('|') !== -1
              ) {
                dataChatVisiteur.dateLastChat = null
              }
            })
            this.datasMonitorVisiteurs = response.data
          }
          this.modifVisiteursMonitor() // modification du tableau general des visiteur si besoin
        })
        .catch()
        .then(_ => {
          this.monitorRequest = false // requette aboutie c'est libre pour une autre requette
        })
    },

    // ----------------------------------------------------------------------
    // il faudrait mettre ca au niveau du dash !!!
    // ----------------------------------------------------------------------
    // INVITATION AUTOMATIQUE
    // ----------------------------------------------------------------------
    autoInvit (data) {
      // socketID, msg, vwId, delay, visiteurID, type, sentence, filId
      // on ajoute quelques seconde le temps de mettre a jour les socketid des visiteurs de la liste
      if (data.sentence === 0) {
        data.delay += 3
      }
      data.msg = data.msg.replace(/%%/g, "'")
      data.msg = data.msg.replace(/autochat_/g, '')
      data.msg = data.msg.replace(/push_/g, '')
      // var messageType = data.type
      var timeout = 1

      if (data.delay !== '') {
        timeout = parseInt(data.delay) * 1000
        // s'il ya deja une invit auto prévue
        for (var key in this.pendingInvit) {
          if (key === data.visiteurID) {
            delete this.pendingInvit[data.visiteurID]
          }
        }
        // et alors mettre la nouvelle invit
        this.pendingInvit[data.visiteurID] = setTimeout(function () {
          this.writeToVis(data)
        }, timeout)
      } else {
        this.writeToVis(data)
      }
    },

    // ----------------------------------------------------------------------
    // Envois automatique d'un message au visiteur
    // ----------------------------------------------------------------------
    writeToVis (data) {
      var dataThisVisiteur = {
        socketID: data.socketID,
        visiteurID: data.visiteurID,
        siteID: data.siteID
      }
      // on connait directement le socketId (phrases preenregistrees)
      if (data.socketIdDest !== '') {
        // envois le message auto au visiteur
        var agentSocketID = this.mySocketID
        // Connexion de l'agent
        _watcheebox.envoisMessage({
          socket: this.$socket,
          agentSocketID: agentSocketID,
          datasAgent: this.user,
          datasVisiteur: dataThisVisiteur,
          message: data.msg,
          messageType: data.type,
          filterId: data.filId,
          agentName: unescape(this.fullName)
        })

        // affiche le message dans le chat de l'agent uniquement des message de l'agent et des phrases preéenregistrées
        if (data.type === 1) {
          // -------------------------------------------------------------------------
          // ecrit le message directement dans l'historique de chat des datasVisiteur
          // -------------------------------------------------------------------------
          // var dateMessage = new Date()
          // var newMessage = {
          //   'auteur': 'Agent',
          //   'message': data.msg,
          //   'nameAuteur': (this.user.fname + ' ' + this.user.lname),
          //   'timestamp': dateMessage,
          //   'type': '1',
          //   'visitorId': data.visiteurID
          // }
          // this.datasVisiteur.histoChat.push(newMessage)
          // addChatMessage({'chatSessionID': visiteurID, 'agentName': agentName, 'txtMessage':msg, 'WZAgentId':agentID})
        }

        // mise à jour de la table all_chatsAuto dans la base moon
        for (var key in this.pendingInvit) {
          if (key === data.visiteurID) {
            delete this.pendingInvit[key]
          }
        }

        if (data.vwId !== '') {
          var config = {
            responseType: 'json',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          }

          var dataAjax = {
            params: {
              id: data.vwId,
              specialtable: data.specialtable
            }
          }
          var file = ''
          if (data.type === 2) {
            file = 'autochatted'
          } else if (data.type === 3) {
            file = 'pushed'
          }
          this.axios
            .get('put/visitor_' + file + '.php', dataAjax, config)
            .then(response => {
              if (!_.isNil(response.data)) {
                // this.datasMonitorVisiteurs = response.data
              }
            })
            .catch()
            .then(_ => {
              // this.loading = false
            })
        }
        // return 1;
      } else {
        // TODO attendre un callback qui confirme l'update de socketId des visiteurs de la liste
        return 0
      }
    },

    // ----------------------------------------------------------------------
    // il faudrait mettre ca au niveau du dash !!!
    // ----------------------------------------------------------------------
    // APPARITION AUTOMATIQUE DU MODULE
    // ----------------------------------------------------------------------
    ouvertureAuto (data) {
      var dataThisVisiteur = {
        socketID: data.socketID,
        visiteurID: data.visiteurID,
        siteID: data.siteID
      }
      setTimeout(() => {
        if (data.socketID !== '') {
          // envois le message auto au visiteur
          var agentSocketID = this.mySocketID
          // Connexion de l'agent
          _watcheebox.forceOuvertureModule({
            socket: this.$socket,
            agentSocketID: agentSocketID,
            datasAgent: this.user,
            datasVisiteur: dataThisVisiteur,
            agentName: unescape(this.fullName)
          })
          return 1
        } else {
          // attendre un callback qui confirme l'update de socketId des visiteurs de la liste
          return 0
        }
      }, 1000) // le temps pour socket io de mettre à jour le data-socketid
    },

    // ----------------------------------------------------------------------------
    // Modification d'un tableau de visiteurs à jour avec ajax "monitor"
    // ----------------------------------------------------------------------------
    modifVisiteursMonitor () {
      // console.log('modifVisiteursMonitor', this.datasMonitorVisiteurs)
      // change cette object en tableau
      this.datasMonitorVisiteurs = _.toArray(this.datasMonitorVisiteurs)
      // pour chaque visiteur que me retourne nodejs
      _.forEach(this.listeAllVisiteurs, (visiteur, key) => {
        if (!visiteur) {
          this.$store.commit('_StoreWatcheeBox/REMOVE_VISITEUR_BY_INDEX', key)
          return
        }

        var index = _.findIndex(this.datasMonitorVisiteurs, {
          visiteurID: visiteur.visiteurID
        })
        if (index === -1) {
          return
        }
        // console.log('index', index)

        // Pour mettre à jours les infos du visiteur avec monitor si elle sont pas encore ajoutées
        if (!visiteur.visiteurName || visiteur.visiteurName === undefined) {
          // console.log('visiteur', visiteur.visiteurName)
          var newDatasVisiteur = _.cloneDeep(visiteur) // pour créer un clone de visiteur
          newDatasVisiteur.visiteurName = this.datasMonitorVisiteurs[index].shortdesc // ajoute la description du visiteur
          newDatasVisiteur.alreadyConsulted = this.datasMonitorVisiteurs[index].alreadyConsulted // ajoute la description du visiteur
          newDatasVisiteur.autoInvit = this.datasMonitorVisiteurs[index].autoInvit // ajoute la description du visiteur
          newDatasVisiteur.autoInvitType = this.datasMonitorVisiteurs[index].autoInvitType // ajoute la description du visiteur
          newDatasVisiteur.autoinvitSend = this.datasMonitorVisiteurs[index].autoinvitSend // ajoute la description du visiteur
          newDatasVisiteur.dateLastChat = this.datasMonitorVisiteurs[index].dateLastChat // ajoute la description du visiteur
          newDatasVisiteur.getplusinfoavailable = this.datasMonitorVisiteurs[index].getplusinfoavailable // ajoute la description du visiteur
          newDatasVisiteur.key = this.datasMonitorVisiteurs[index].key // ajoute la description du visiteur
          newDatasVisiteur.keyVis = this.datasMonitorVisiteurs[index].keyVis // ajoute la description du visiteur
          newDatasVisiteur.listAlert = this.datasMonitorVisiteurs[index].listAlert // ajoute la description du visiteur
          newDatasVisiteur.nbCustomAlert = this.datasMonitorVisiteurs[index].nbCustomAlert // ajoute la description du visiteur
          newDatasVisiteur.nb_alert = this.datasMonitorVisiteurs[index].nb_alert // ajoute la description du visiteur
          newDatasVisiteur.nbchats = this.datasMonitorVisiteurs[index].nbchats // ajoute la description du visiteur
          newDatasVisiteur.pagesFocus = this.datasMonitorVisiteurs[index].pagesFocus // ajoute la description du visiteur
          newDatasVisiteur.ponderation = this.datasMonitorVisiteurs[index].ponderation // ajoute la description du visiteur
          newDatasVisiteur.savedConversation = this.datasMonitorVisiteurs[index].savedConversation // ajoute la description du visiteur
          newDatasVisiteur.visId = this.datasMonitorVisiteurs[index].visId // ajoute la description du visiteur
          newDatasVisiteur.visitorApiInfo = this.datasMonitorVisiteurs[index].visitorApiInfo // ajoute la description du visiteur
          newDatasVisiteur.wz_textSocialNotif = this.datasMonitorVisiteurs[index].wz_textSocialNotif // ajoute la description du visiteur

          this.$store.commit('_StoreWatcheeBox/SET_VISITEURS', newDatasVisiteur)
          // console.log('newDatasVisiteur', newDatasVisiteur)
        }

        // Pour l'envois des autoinvites et ouverture auto
        var newDatas = this.datasMonitorVisiteurs[index] // pour créer un nouvel element
        newDatas.status = visiteur.status
        newDatas.socketID = visiteur.socketID
        newDatas.notification = visiteur.notification
        newDatas.lang = visiteur.lang
        newDatas.roomName = visiteur.roomName
        newDatas.siteID = visiteur.siteID
        // regarde le status du visiteur et le socket
        if (!visiteur.connexion && !visiteur.socketID) {
          // si le visiteur déconnecté n'est pas en session chat avec moi
          // test le focus chat de l'agent (pour la page visiteur')
          if (this.focusPupitre.focusSessionID !== visiteur.visiteurID) {
            // regarde dans les sessions chat actives
            var indexChatSession = _.findIndex(this.sessionsPrivees, [
              1,
              visiteur.visiteurID
            ])
            if (indexChatSession === -1) {
              // supprime le visiteur definitivement de 'listeAllVisiteurs'
              this.$store.commit('_StoreWatcheeBox/REMOVE_VISITEUR', visiteur)
            }
          }
        } else {
          if (this.datasMonitorVisiteurs[index].nb_alert !== 0) {
            // regarde si il y a un filtre d'activé pour ce visiteur
            if (newDatas.filteridcalled) {
              // si il y a un filtre on envois la fonction autoinvit
              var dataInvit = {
                socketID: newDatas.socketID,
                msg: newDatas.autoInvit,
                vwId: newDatas.visId,
                delay: '',
                visiteurID: newDatas.visiteurID,
                type: Number(newDatas.autoInvitType),
                sentence: '0',
                filId: newDatas.filteridcalled,
                siteID: newDatas.siteID,
                roomName: newDatas.roomName
              }
              this.autoInvit(dataInvit)
            }

            // regarde si l'ouverture automatique est activé pour ce visiteur
            if (newDatas.forceAppear) {
              var dataOuvertureAuto = {
                socketID: newDatas.visiteurID,
                visiteurID: newDatas.visiteurID,
                siteID: newDatas.siteID
              }
              // Force l'ouverture automatique du module
              this.ouvertureAuto(dataOuvertureAuto)
            }
          }
        }
      })
    }
  },

  computed: {
    ...mapGetters('_User', ['user', 'fullName', 'level']),
    ...mapState('_StoreWatcheeBox', [
      'visiteurChatSelected',
      'sessionsPrivees',
      'focusPupitre',
      'allDataVisiteurOpened',
      'listeAllVisiteurs'
    ]),
    // ...mapGetters('_StoreWatcheeBox', ['listeAllVisiteurs']),

    allChatsOpened () {
      return _.uniq(_.map(this.listeChatAgent, 0))
    },
    // num total Visiteurs
    numTotalVisiteur () {
      return (
        this.datasFilterVisiteursArray.length +
        this.datasNoFilterVisiteursArray.length +
        this.datasVisiteursSocialNetwokArray.length
      )
    },
    concatAllVisiteurs () {
      // uniquement si pas de ciblage en front
      // on utiliser les donnée du monitor et on les concat avec 'listeAllVisiteur'
      if (!this.filterFront) {
        let res = []
        _.each(this.listeAllVisiteurs, nodeVis => {
          let found = _.find(this.datasMonitorVisiteurs, {
            visiteurID: nodeVis.visiteurID
          })
          if (found) {
            let newVis = {}
            _.each(found, (v, k) => {
              // console.log('v', v)
              // console.log('k', k)
              newVis[k] = v
            })
            _.each(nodeVis, (v, k) => {
              // console.log('v', v)
              // console.log('k', k)
              newVis[k] = v
            })
            // console.log('newVis', newVis)
            res.push(newVis)
          } else {
            res.push(nodeVis)
          }
        })
        // console.log('res', res)
        return res
      } else {
        // Si ciblage en front on peut utiliser directement 'listeAllVisiteurs' du store
        return this.listeAllVisiteurs
      }
    },
    // visteursFiltrés
    datasFilterVisiteursArray () {
      return _.sortBy(
        _.filter(this.concatAllVisiteurs, function (o) {
          return o.nb_alert > 0
        }),
        ['nb_alert', 'ponderation', 'dateLastChat']
      ).reverse()
    },
    datasNoFilterVisiteursArray () {
      return _.filter(this.concatAllVisiteurs, function (o) {
        return (
          !o.network &&
          (!o.nb_alert || (o.nb_alert && o.nb_alert === 0 && !o.network))
        )
      })
    },
    datasVisiteursSocialNetwokArray () {
      return _.filter(this.concatAllVisiteurs, function (o) {
        return o.network && (!o.nb_alert || (o.nb_alert && o.nb_alert === 0))
      })
    },
    computedAllDataVisiteurOpened () {
      return this.allDataVisiteurOpened
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/monitor.js